import type { CurrentUser, SessionAdapter } from '@zhiyue/core';

import { BizAppConfig } from 'config/application.manifest';
import {
  createTenant as createTenantApi,
  deleteTenant as deleteTenantApi,
  getCurrentMemberUser,
  getTenantByCode as getTenantByCodeApi,
  getTenantList as getTenantListApi,
  joinTenant as joinTenantApi,
  logout as logoutApi,
  switchTenant as switchTenantApi,
} from '@/services/bff';
import {
  clearOAuth2Tokens,
  ensureValidAccessToken,
  markLogoutInProgress,
  resolveSsoConfig,
} from '@/services/oauth2';

export const sessionAdapter: SessionAdapter = {
  fetchCurrentUser: async () => {
    await ensureValidAccessToken();
    const user = (await getCurrentMemberUser()) as CurrentUser &
      API.CurrentUser;
    console.log('[memberUuid][frontend] current session user', {
      memberUuid: user.memberUuid,
      userUuid: user.uuid,
      tenantUuid: user.tenantUuid,
      organizationUuid: user.organizationUuid,
    });
    return user;
  },
  fetchTenants: async () => {
    return (await getTenantListApi()) || [];
  },
  switchTenant: async (organizationUuid: string) => {
    await switchTenantApi(organizationUuid);
  },
  createTenant: async ({ tenantName }: { tenantName: string }) => {
    return createTenantApi({ tenantName });
  },
  lookupTenantByCode: async (code: string) => getTenantByCodeApi(code),
  joinTenant: async (payload: { tenantUuid: string; nodeId: string }) =>
    joinTenantApi(payload),
  deleteTenant: async (tenantUuid: string) => deleteTenantApi(tenantUuid),
  logout: async () => {
    markLogoutInProgress();
    const ssoConfig = await resolveSsoConfig();
    const logoutBaseUrl = ssoConfig.logoutUrl || BizAppConfig.appSsoLogoutUrl;
    const redirectUri = `${window.location.origin}/user/login`;
    const logoutUrl = logoutBaseUrl
      ? `${logoutBaseUrl}?redirect_uri=${encodeURIComponent(redirectUri)}`
      : redirectUri;

    try {
      await logoutApi(BizAppConfig.appSsoClientId as string, {
        skipErrorHandler: true,
      });
    } catch {
      // Keep local logout flow even when backend logout fails.
    }

    clearOAuth2Tokens();
    return { logoutUrl };
  },
};
